<script>
  import { push } from 'svelte-spa-router';
  import { logout } from '@lib/api/auth.js';
  export let userName= ''; // 사용자 이름 프롭으로 받을 수 있음
  
  let activeRoute = 'dashboard'; // 초기 선택값

  const navItems = [
    { name: '대시보드', route: 'dashboard' },
    { name: '사용자관리', route: 'users' },
    { name: '문제유형관리', route: 'problem-type' },
    { name: '1:1문의', route: 'inquiry' },
    { name: '공지사항', route: 'notice' },
    { name: '서비스이력', route: 'svc-history' },
    { name: '플랜관리', route: 'planmng' }
  ];

  function handleClick(route) {
    activeRoute = route;
    push(`/${route}`);
  }

  async function handleLogout() {
      try {
          await logout();
          push('/'); // 메인 페이지로 이동
      } catch (e) {
          alert(e.message);
      }
  }
</script>
<header class="header">
  <div class="header-inner">
    <h1 class="logo">
     <a href="/#/dashboard" class="btn-logo" on:click|preventDefault={() => handleClick('dashboard')}>
        <span class="img-wrap">
          <img src="/image/img-logo.png" alt="4seasonAI 출재쌤" />
        </span>
      </a>
      <span class="text-hide">4season ai 출재쌤</span>
    </h1>

    <div class="gnb">
      {#each navItems as item}
        <a
          href="javascript:void(0);"
          class:is-active={activeRoute === item.route}
          on:click={() => handleClick(item.route)}
        >
          {item.name}
        </a>
      {/each}
    </div>

    <div class="util">
      <p>{userName}</p>
      <span></span>
      <button type="button" class="btn-logout" on:click={handleLogout}>
        <i class="icon icon-logout"></i>
        로그아웃
      </button>
    </div>
  </div>
</header>